<template>
  <v-menu
      v-model="show"
      bottom
      left
      nudge-bottom="50"
      nudge-left="300"
      close-on-click
      :close-on-content-click="false"
      min-width="450px"
  >
    <template #activator="{on, attrs}">
      <v-btn
          icon
          v-on="on"
          v-bind="attrs"
          :loading="loading"
          @click=" show= !show"
      >
        <v-icon size="24" color="info">
          mdi-lock-open-outline
        </v-icon>
      </v-btn>
    </template>
    <v-card class="contact-menu-card">
      <v-btn class="close-click" icon @click="show = false">
        <v-icon size="24" color="primary">mdi-close</v-icon>
      </v-btn>
      <template v-if="!loading">
        <v-card-title>
          <slot name="header-title">
            <h3>

            </h3>
          </slot>
          <slot name="header-subtitle">

          </slot>
        </v-card-title>
        <v-card-text
            class="d-flex flex-column"
        >
<!--          <div class="font-weight-600 main-color"></div>-->
          <div class="font-weight-600">Статус блокировки:
            <v-btn class="white__v-btn" :loading="blocking" @click="blockOrg">
              {{blockInfo.block ? 'Заблокировано' : 'Не заблокировано'}}
            </v-btn>
          </div>
          <div class="font-weight-600 mt-2">Наличие конверта:
            <v-btn class="white__v-btn" :loading="konvertLoading" @click="konvertOrg">
              {{blockInfo.konvert ? 'да' : 'нет'}}
            </v-btn>
          </div>
          <div class="">Дата и номер конверта: {{ blockInfo.konvertDate }} {{ blockInfo.konvertNumber }}</div>
          <div class="font-weight-600">Принят конверт: {{ blockInfo.konvertAccept ? 'да' : 'нет' }}</div>
          <div class="">Дата принятия конверта: {{ blockInfo.konvertAcceptDate }}</div>
          <div class="">Скан конверта: <span v-if="blockInfo.scanFileKonvert" @click="getFile(blockInfo.scanFileKonvert.id)">скачать файл</span></div>
<!--          <div class="font-weight-600">{{ contactOne.fio }}</div>-->
<!--          <div>{{ contactOne.position }}</div>-->
<!--          <div class="mt-5">Рабочий телефон: <span class="font-weight-600">{{ contactOne.workPhoneNumber }}</span></div>-->
<!--          <div>Мобильный телефон: <span class="font-weight-600">{{ contactOne.personalPhoneNumber }}</span></div>-->
<!--          <div>Электронная почта: <span class="main-color font-weight-600">{{ contactOne.email }}</span></div>-->
        </v-card-text>
      </template>
      <v-card-text v-else class="justify-center align-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import UserController from "@/controllers/UserController";
import {setFileFunctions} from "@/mixins/fileFucntions";

export default {
  name: "block-menu",
  mixins: [setFileFunctions],
  props: {
    id: {
      type: Number,
      required: true,
      default: 0,
      validator: (v) => {
        return +v > 0
      },
    }
  },
  data() {
    return {
      show: false,
      loading: false,
      blocking: false,
      konvertLoading: false,
      blockInfo: {

      }
    }
  },
  watch: {
    show(newValue) {
      if (newValue)
        this.getServerInfo()
    }
  },
  methods: {
    getServerInfo() {
      this.loading = true;
      UserController.getBlockInfo('org', this.id).then(data =>{
        this.blockInfo = data;
      }).finally(() => this.loading = false)
    },
    blockOrg(){
      this.blocking = true;
      UserController.setBlockOrganization(!this.blockInfo.block, "ORG_BLOCK", this.id).then(data => {
        this.blockInfo = data
      }).finally(() => this.blocking = false)
    },
    konvertOrg(){
      this.konvertLoading = true;
      UserController.setBlockOrganization(!this.blockInfo.konvert, "KONVERT_BLOCK", this.id).then(data => {
        this.blockInfo = data
      }).finally(() => this.konvertLoading = false)
    },
  },
}
</script>

<style scoped>

</style>